<div class="checkbox-switch" [formGroupName]="groupName">
    <input type="checkbox" [formControlName]="controlName" class="input-checkbox" (change)="changeValue()">
    <div class="checkbox-animate">
       <span class="checkbox-off">{{offLabel}}</span>
       <span class="checkbox-on">{{onLabel}}</span>
    </div>
 </div>